import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const StopWatchIconSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M6.72328 13.3314H11.9913C12.3392 13.3314 12.6096 13.0649 12.6096 12.7217V5.92277C12.6096 5.57484 12.3392 5.31226 11.9913 5.31226C11.6599 5.31226 11.3895 5.57484 11.3895 5.92277V12.1112H6.72328C6.37145 12.1112 6.11756 12.3816 6.11756 12.7217C6.11756 13.0649 6.37145 13.3314 6.72328 13.3314ZM12 22.3174C17.4734 22.3174 22.0087 17.7908 22.0087 12.3174C22.0087 6.84397 17.4647 2.31738 11.9913 2.31738C6.52267 2.31738 2 6.84397 2 12.3174C2 17.7908 6.53139 22.3174 12 22.3174ZM12 20.8446C7.2804 20.8446 3.48627 17.0457 3.48627 12.3174C3.48627 7.58905 7.27168 3.79014 11.9913 3.79014C16.7196 3.79014 20.5273 7.58905 20.5273 12.3174C20.5273 17.0457 16.7283 20.8446 12 20.8446Z"
        fill={color}
      />
    </svg>
  );
};

export { StopWatchIconSvg };
